import * as React from "react";
import { Block } from "../Block";
import { useStyletron } from "kanopi-components/theme/useStyletron";
/**
 * TODO: Confirm if existing Container component is used. If so, let this have that name.
 */

type TKontainerProps = {
  fluid?: boolean;
  children?: React.ReactNode;
};

/**
 * Container purely for width-control.
 * Anything we render should have only one ancestor Container.
 * A 'fluid' one does not limit the width, but still enforces the appropriate
 * horizontal padding.
 */
const Kontainer: React.FC<TKontainerProps> = ({ fluid, children, ...restProps }) => {
  // TODO: Should theme have a separate max-width property?
  const [, theme] = useStyletron();
  const maxWidth = theme.grid.maxWidth + "px";

  return (
    <Block
      // TODO: Confirm why maxWidth is being applied to a fluid container at two smallest breakpoints
      maxWidth={[maxWidth, maxWidth, fluid ? undefined : maxWidth]}
      marginLeft="auto"
      marginRight="auto"
      // TODO: Revert these to original paddings, can be overridden via props if needed
      paddingLeft={[0, 0, "scale600"]}
      paddingRight={[0, 0, "scale600"]}
      {...restProps}
    >
      {children}
    </Block>
  );
};

export { Kontainer };
